import api from "./apiSmartLogistics.js";

export default {
  InsertArticle(article) {
    return api.post("operations/InsertArticle", article);
  },

  GetOperations() {
    return api.get("operations/GetOperations");
  }
};
